'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import {
  buildPaymentReturnPath,
  buildRelativePath,
  PAYMENT_RETURN_PATH,
} from '@/lib/payment';

export function usePaymentReturn() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const handledOrderIdRef = useRef<string | null>(null);

  useEffect(() => {
    const orderId = searchParams.get('checkout_order_id');
    if (!orderId || pathname === PAYMENT_RETURN_PATH || handledOrderIdRef.current === orderId) {
      return;
    }

    handledOrderIdRef.current = orderId;

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.delete('checkout_order_id');
    const returnTo = buildRelativePath(nextUrl.pathname, nextUrl.search, nextUrl.hash);
    const redirectPath = buildPaymentReturnPath(returnTo);
    const redirectUrl = new URL(redirectPath, window.location.origin);
    redirectUrl.searchParams.set('checkout_order_id', orderId);

    router.replace(`${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`, {
      scroll: false,
    });
  }, [pathname, router, searchParams]);
}